// extracted by mini-css-extract-plugin
export var base = "_49-0";
export var updateBanner = "_49-1";